/**
 * Morse „Augen zu“ — „Gerade dran“ als Kacheln. (13.10.2026, Martin: die Zeile „K M U R“ sei eine „Wurst“)
 *
 * Eine echte Liste (ul/li): je Zeichen eine gleich große, abgerundete Kachel mit dem Buchstaben und darunter dem kleinen
 * Morse-Bild (morse-bild.ts). Das NEUE Zeichen der Stufe trägt Akzent und das Schild „neu“, alle anderen sind ruhig. Bis
 * `KACHELN_DICHT_AB` Zeichen mit Bild; darüber („Alle Zeichen“: 41) kompakt — kleinere Kacheln, nur der Buchstabe. Die Liste
 * sagt es Screenreadern in einem Satz („Gerade dran: K, M, U, R“); die Kacheln selbst sind Beiwerk fürs Auge.
 *
 * Merkwort (15.10.2026, Martin: „einen Anhalt, dass ich das richtig erkenne“): mit `merkwort: true` steht unter dem Bild das
 * geprüfte Merkwort (morse-merkwort.ts), klein; die Kachel wächst dann in der Breite mit. Ob es da steht, entscheidet der Aufrufer
 * (Augen zu: der Schalter „Buchstabe zeigen“ — bei „Aus“ keine Sehhilfe). Kompakt (viele Zeichen) nie.
 *
 * ⚠️ Keine Inline-Styles: alles in style.css (`.morse-dran…`).
 */
import { MORSE_TABELLE } from "../../shared/morse.js";
import { musterBild } from "./morse-bild.js";
import { merkwortAria, merkwortElement } from "./morse-merkwort.js";
import { AUGEN } from "./morse-texte.js";
import { el } from "./morse-teile.js";

/** Ab so vielen Zeichen: kompakt, ohne Bild. */
export const KACHELN_DICHT_AB = 13;

export function baueKacheln(zeichen: readonly string[], neue: readonly string[], o: { merkwort?: boolean } = {}): HTMLElement {
  const wurzel = el("div", "morse-dran");
  const dicht = zeichen.length >= KACHELN_DICHT_AB;
  const mitMerkwort = o.merkwort === true && !dicht;
  wurzel.dataset.dicht = String(dicht);
  if (mitMerkwort) wurzel.dataset.merkwort = "true";
  wurzel.appendChild(el("p", "morse-dran-titel", AUGEN.menge.titel));
  const liste = el("ul", "morse-dran-liste");
  liste.setAttribute("aria-label", AUGEN.menge.aria(zeichen));
  for (const z of zeichen) {
    const li = el("li", "morse-dran-kachel");
    const istNeu = neue.includes(z);
    if (istNeu) li.dataset.neu = "true";
    li.append(el("span", "morse-dran-name", z));
    if (!dicht) li.appendChild(musterBild(MORSE_TABELLE[z] ?? "", "s"));
    const merk = mitMerkwort ? merkwortElement(z, "morse-dran-merk") : null;
    if (merk) li.appendChild(merk);
    if (istNeu) li.appendChild(el("span", "morse-dran-marke", AUGEN.menge.neu));
    // Die Kachel ist fürs Auge; Zeichen und „neu“ liest die Liste vor (kein doppeltes Muster-Vorlesen je Kachel) — das
    // Merkwort hängt am Namen der Kachel, damit es vorlesbar ist.
    const name = istNeu ? `${z}, ${AUGEN.menge.neu}` : z;
    li.setAttribute("aria-label", merk ? `${name}, ${merkwortAria(z)}` : name);
    liste.appendChild(li);
  }
  wurzel.appendChild(liste);
  return wurzel;
}
